<div class="row " id="patient-page">
    <app-modaldisclaimer></app-modaldisclaimer>
   

    <div class="col-md-4 col-sm-12 patientform">
        <form [formGroup]="patientConfiguration" (ngSubmit)="onSubmit()" novalidate>
            <!-- <div class="form-group">
        <div class="row">
          <div class="col-md-6 col-sm-12 patient-measurement__unit patient-measurement__weight">
            <label>Peso (Kg)</label>
            <div class= "formdata Hieght" [ngClass]= '{"is-error-text": submitted && f.Wieght.invalid}'>
              <input type="text" formControlName="Wieght" class="form-control" name="peso" [ngClass]="{ 'is-invalid': (submitted && f.Wieght.errors) || (f.Wieght.touched && f.Wieght.dirty && !f.Wieght.valid)}" [readonly]="!_buttonValue"/>
            </div>
            <div class="is-error" *ngIf="submitted && f.Wieght.errors || (f.Wieght.touched && !f.Wieght.valid)">
              <div *ngIf="f.Wieght.errors.required"> Campo obligatorio</div>
              <div *ngIf="f.Wieght.errors.pattern"> Por favor, introduzca valores numéricos</div>
              <div *ngIf="f.Wieght.errors.min ||f.Wieght.errors.max  "> Rango: 30-200 kg</div>

            </div>
      
          </div>
          <div class="col-md-6 col-sm-12 patient-measurement__unit patient-measurement__height" >
            <label>Altura   (cm)</label>
            <div class="height" [ngClass]= '{"is-error-text": submitted && f.Hieght.invalid}'>
            <input type="text" formControlName="Hieght" class="form-control" name="altura" [ngClass]="{ 'is-invalid': (submitted && f.Hieght.errors) || (f.Hieght.touched && !f.Hieght.valid)} " [readonly]="!_buttonValue"/>
          </div>
            <div class="is-error" *ngIf="submitted && f.Hieght.errors || (f.Hieght.touched && !f.Hieght.valid)">
               <div *ngIf="f.Hieght.errors.pattern">Por favor, introduzca valores numéricos</div>
              <div *ngIf="f.Hieght.errors.required">Campo obligatorio</div>
              <div *ngIf="f.Hieght.errors.min ||f.Hieght.errors.max  "> Rango: 100-250 cm</div>

            </div>
          </div>
        </div>
      </div>    -->

            <div class="treatment-details">
                <h4 i18n="@@treatmentHeader" class="tratamientoClass">Treatment header en</h4>
                <div class="treatoptions" [ngClass]="{'is-error-radio': submitted && Tratamientos.invalid}">
                    <div *ngIf="_dvmp.optedTreatments.DVMP" class="radio">
                        <input id="radio1" type="radio" value="DVmp" formControlName="Tratamientos" />
                        <label for='radio1'>
                            <span appSuperscript i18n="@@treatmentDvmp">Treatment dvmp en</span>
                        </label>
                    </div>
                    <div *ngIf="_dvmp.optedTreatments.DVD" class="radio">
                        <input id="radio2" type="radio" value="DVd" formControlName="Tratamientos" />
                        <label for='radio2'>
                            <span appSuperscript i18n="@@treatmentDvd">Treatment dvd en</span>
                        </label>
                    </div>
                    <div *ngIf="_dvmp.optedTreatments.DRD" class="radio">
                        <input id="radio3" type="radio" value="DRd" formControlName="Tratamientos" />
                        <label for='radio3'>
                            <span appSuperscript i18n="@@treatmentDRd">Treatment dRd en</span>
                        </label>
                    </div>
                    <div *ngIf="_dvmp.optedTreatments.D" class="radio">
                        <input id="radio4" type="radio" value="D" formControlName="Tratamientos" />
                        <label for='radio4'>
                            <span appSuperscript i18n="@@treatmentD">Treatment d en</span>
                        </label>
                    </div>
                    
                    <div *ngIf="submitted && Tratamientos.invalid">
                        <p i18n="@@treatmentErrMsg" [ngStyle]="{'color': 'red'}">Treatment err msg en</p>
                    </div>
                </div>
            </div>
            <div *ngIf="_dvmp.formulation">
                <h4 class="tratamientoClass">Formulación </h4>
                <div class="treatoptions" [ngClass]="{'is-error-radio': submitted && Formulation.invalid}">
                    <div class="radio formulation">
                        <input id="fradio1" type="radio" value="SC" formControlName="Formulation" />
                        <label for='fradio1'>
                            <span>Darzalex<sup>®</sup> SC </span>
                        </label>
                    </div>
                    <div class="radio formulation">
                        <input id="fradio2" type="radio" value="IV" formControlName="Formulation" />
                        <label for='fradio2'>
                            <span>Darzalex<sup>®</sup> IV </span>
                        </label>
                    </div>
                    <div *ngIf="submitted && Formulation.invalid">
                        <p i18n="@@treatmentErrMsg" style="font-weight: 700;font-size: 14px;" [ngStyle]="{'color': 'red'}">Treatment err msg en</p>
                    </div>
                </div>
            </div>

            <div class=" form-group ">
                <label i18n="@@startCycle">Start cycle en</label>

                <div class=" current-cycle " [ngClass]='{"is-error-text": submitted && f.Cicle.invalid}'>
                    <input type="number" formControlName="Cicle" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.Cicle.errors) || (f.Cicle.touched && !f.Cicle.valid)} "
                        [readonly]="!_buttonValue" />
                </div>
                <div class="is-error" *ngIf="submitted && f.Cicle.errors || (f.Cicle.touched && !f.Cicle.valid)">
                    <div i18n="@@treatmentErrMsg" *ngIf="f.Cicle.errors.required">Start cycle empty err msg en</div>
                    <div i18n="@@startCycleNegErrMsg" *ngIf="f.Cicle.errors.min">Start cycle neg err msg en</div>
                    <div i18n="@@startCycleMoreErrMsg" *ngIf="f.Cicle.errors.max">Start cycle more err msg en</div>
                </div>
            </div>
            <div class="form-group fecha-block clearfix material-calender">
                <label for="Fechaactual">{{treatStartDate}}</label>
                <!-- date picker start here -->
                <!-- <mat-form-field class="example-full-width" >
              <input matInput [matDatepicker]="picker" (click)="picker.open();picker.select();" [formControl]="serializedDate"  placeholder="Choose a date"> 
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker touchUi #picker ></mat-datepicker>
          </mat-form-field>     -->
                <!-- <mat-form-field>
              <input matInput [matDatepicker]="picker" (click)="picker.open();picker.select();" formControlName="Fechaactual" (dateChange)="onChange($event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>  
              <span class="dateformat">
                {{fechaactualmodal}}
              </span>
          </mat-form-field>         -->
                <input mdInput [matDatepicker]="picker" [matDatepickerFilter]="myFilter" (click)="picker.open();" formControlName="Fechaactual"
                    (dateChange)="onChange($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>

                <!-- date picker end here -->
                <span class="FechaactualDate">{{FechaactualDate}}</span>

                <div class="is-error" *ngIf="submitted && f.Fechaactual.errors">
                    <div i18n="@@treatmentErrMsg" *ngIf="f.Fechaactual.errors.required">Treat start date err msg en</div>
                </div>
            </div>
            <div class=" form-group upper-space">
                <label i18n="@@numberOfCycles">Number of cycles en</label>
                <div class=" current-cycle " [ngClass]='{"is-error-text": submitted && f.Nocicle.invalid}'>
                    <input type="number" formControlName="Nocicle" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.Nocicle.errors) || (f.Nocicle.touched && !f.Nocicle.valid)} "
                        [readonly]="!_buttonValue" />
                </div>
                <div class="is-error" *ngIf="submitted && f.Nocicle.errors || (f.Nocicle.touched && !f.Nocicle.valid)">
                    <div i18n="@@treatmentErrMsg" *ngIf="f.Nocicle.errors.required">Number of cycles req err msg en</div>
                    <div i18n="@@startCycleNegErrMsg" *ngIf="f.Nocicle.errors.min">Number of cycles neg err msg en</div>
                    <div i18n="@@startCycleMoreErrMsg" *ngIf="f.Nocicle.errors.max">Number of cycles more err msg en</div>
                </div>
            </div>

            <div *ngIf="_dvmp.enableInputTextboxes" class="form-group observ">
                <label i18n="@@observationHeader" for="Observaciones">Observation header en</label>
                <textarea class="form-control  rounded-0" id="exampleFormControlTextarea1" formControlName="observations" rows="3" [ngClass]="{ 'is-invalid':  f.observations.errors }"
                    [readonly]="!_buttonValue" maxlength="1000" (ngModelChange)="eventHandler($event)"></textarea>

                <div class="is-error" *ngIf="f.observations.errors || (f.observations.touched && !f.observations.valid)">
                    <div *ngIf="f.observations.errors.maxlength"> only {{this.f.observations.errors.maxlength.requiredLength}} charcs are allowed</div>
                </div>

                <!-- <iframe src="https://calendar.google.com/calendar/embed?src=en.indian%23holiday%40group.v.calendar.google.com&ctz=Asia%2FKolkata" style="border: 0" width="800" height="600" frameborder="0" scrolling="no"></iframe>-->

            </div>
            <div class="form-group landing">
                <div i18n="@@observationHeaderWarning" class="disclaimerBorder" *ngIf="show">[Placeholder for pharmacovigilance guide, the Spanish version telles the HCPs the email (J&J) and website (of the Spanish competent authority) where side effects can be notified].</div>
                <div class="button-contain">
                    <button i18n="@@following" class="btn btn-primary" *ngIf="_buttonValue;else locTemp">{{ "Following en" | uppercase }}</button>
                    <div></div>
                    <div (click)="Reset()" class='btn btn-primary pdf'>
                        <i class="fas fa-users"></i>
                        <span i18n="@@newPatientButton">{{"New patient button en" | titlecase }}</span></div>
                </div>
                <ng-template #locTemp>
                    <button class="btn btn-primary" (click)="clickEvent($event)">{{ "EDIT" }}</button>
                </ng-template>
            </div>
        </form>
        <div i18n="@@termsButton" class="terms-condition-btn" (click)="termsconditionclick()">Terms button en</div>
    </div>

    <div class="col-md-8 col-sm-12">
        <app-treatment [patientdata]="patientdata" *ngIf="submitted && formvalidated"></app-treatment>
    </div>
    <!-- <p>El esquema seleccionado no está recogido en el punto 4.2 de Ficha Técnica</p> -->
</div>

<!--Legal first time disclaimer modal start here -->
<div class="modal legal" id="legalDisclaimer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 i18n="@@termsModalHeading" class="title legaldisclaimer">Terms modal heading en</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="close()" *ngIf="_termsconditionFlag">&times;</button>
            </div>
            <div class="modal-body" id="legalDisclaimerBody" (scroll)="scrollHandler($event)">

                <div class="loading window">
                    <p _ngcontent-c1="" class="title text-center">
                        <p i18n="@@termsSec1">Terms section en
                        </p>
                        {{termsEx}}
                        <div i18n="@@termsHeading" class="heading" style="margin-bottom:10px;text-decoration: underline;text-align: center !important;font-weight: bolder;">Terms heading en</div>
                        <ul class="tculstyle">
                            <!-- <li i18n="@@termsSec2">Terms section en
                            </li> -->
                            <li i18n="@@termsSec3">Terms section en
                            </li>
                            <li i18n="@@termsSec4">Terms section en
                            </li>
                            <li i18n="@@termsSec5">Terms section en
                            </li>
                            <li i18n="@@termsSec6">Terms section en</li>
                            <li i18n="@@termsSec7">Terms section en
                            </li>
                            <li i18n="@@termsSec8">Terms section en
                            </li>
                            <li i18n="@@termsSec9">Terms section en
                            </li>
                            <li i18n="@@termsSec10">Terms section en
                            </li>
                        </ul>
                        <ul class="tculstyle">
                            <li>
                                <span i18n="@@termsSec11" style="text-decoration: underline;">
                                    Terms section en
                                </span>
                                <p i18n="@@termsSec12" style="font-style: italic;margin-top: 5px;">Terms section en</p>
                                <p i18n="@@termsSec13">Terms section en
                                </p>
                                <ul class="beforeP">
                                    <li i18n="@@termsSec14" style="padding-left: 0px;list-style-type: square;">
                                        Terms section en
                                    </li>
                                </ul>
                                <p i18n="@@termsSec15">
                                    Terms section en
                                </p>
                                <p i18n="@@termsSec16">Terms section en</p>
                                <p i18n="@@termsSec17">Terms section en
                                </p>
                                <p i18n="@@termsSec18">Terms section en
                                </p>
                                <ul class="beforeP">
                                    <li i18n="@@termsSec19" style="padding-left: 0px;list-style-type: square;">
                                        Terms section en
                                    </li>
                                    <li i18n="@@termsSec20" style="padding-left: 0px;list-style-type: square;">
                                        Terms section en
                                    </li>
                                </ul>
                                <p i18n="@@termsSec21" style="font-style: italic;margin-top: 5px;">
                                    Terms section en
                                </p>
                                <p i18n="@@termsSec22">Terms section en
                                </p>
                                <p i18n="@@termsSec23">
                                    Terms section en
                                </p>
                                <p i18n="@@termsSec24">Terms section en
                                </p>
                                <p i18n="@@termsSec25">Terms section en
                                </p>
                                <p i18n="@@termsSec26">Terms section en
                                </p>
                                <p i18n="@@termsSec27">Terms section en
                                </p>
                                <p i18n="@@termsSec28" style="font-style: italic">Terms section en
                                </p>
                                <p i18n="@@termsSec29">Terms section en
                                </p>
                            </li>

                            <li i18n="@@termsSec30">Terms section en
                            </li>
                        </ul>
                        <input type="checkbox" name="termscondition" [(ngModel)]="flagcheck" id="flag" *ngIf="!_termsconditionFlag">
                        <label for="flag" *ngIf="!_termsconditionFlag">
                            <span i18n="@@termsChekText">Terms chek text en</span>
                            <br>
                        </label>
                </div>
                <div class="Termscontainer">
                    <p i18n="@@termsCheckErrMsg" class="error-msg" *ngIf='_errorflag'>
                        Terms check err msg en
                    </p>
                    <div class="text-right-btn" *ngIf="!_termsconditionFlag">
                        <button i18n="@@following" (click)="nextClick()" class='btn btn-primary pdf'>Following en</button>
                    </div>
                </div>


                <div *ngIf="_termsconditionFlag" class="text-right">
                    <button i18n="@@closeBtn" type="button" class="btn btn-primary" data-dismiss="modal" (click)="close()">Close btn en</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Legal first time disclaimer modal start here -->